import { render, staticRenderFns } from "./TreasureQuality.vue?vue&type=template&id=715ffd5c"
import script from "./TreasureQuality.vue?vue&type=script&lang=js"
export * from "./TreasureQuality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports